import type { FC } from 'react'
import { useState } from 'react'

import UnableToVerifyButton from '@/components/UnableToVerifyButton'
import type { Address } from '@/types/Activity'

import UnableToVerifyAddressSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  address: Address
  disabled?: boolean
}

const UnableToVerifyAddress: FC<Props> = ({
  customerId,
  subjectId,
  address,
  disabled,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  const isDisabled =
    address.status !== 'Renting' ||
    (address.verification !== null &&
      address.verification !== undefined &&
      address.verification.state !== 'notVerified') ||
    disabled === true

  return (
    <>
      {isSidebarOpen && (
        <UnableToVerifyAddressSidebar
          customerId={customerId}
          subjectId={subjectId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <UnableToVerifyButton
        disabled={isDisabled}
        onClick={() => setIsSidebarOpen(true)}
      />
    </>
  )
}

export default UnableToVerifyAddress
